export default {
  name: "MlFooter",
  computed: {
    color: function color() {
      if (typeof this.$route.meta.footerColor === "undefined") {
        return "transparent";
      }
      return this.$route.meta.footerColor;
    }
  },
  props: {}
};